import { useId, useMemo, useState } from 'react';
import type { AnalyticsEvent, AnalyticsFilters } from '../../services/analytics';
import { AccountTableCard } from './AccountTableCard';
import { formatSubscriptionStatus } from './accountTables';
import { DEFAULT_EVENT_ID, eventOptions } from './events';
import styles from './EventsByCustomer.module.css';

interface EventsByCustomerProps {
    events: AnalyticsEvent[] | undefined;
    filters: AnalyticsFilters;
    enabled: boolean;
    refreshKey: number;
    timeZone: string;
}

const FORMATTERS = { assinatura: formatSubscriptionStatus };

export function EventsByCustomer({ events, filters, enabled, refreshKey, timeZone }: EventsByCustomerProps) {
    const selectId = useId();
    const options = useMemo(() => eventOptions(events), [events]);
    const [event, setEvent] = useState(DEFAULT_EVENT_ID);

    return (
        <AccountTableCard
            name="eventos-por-cliente"
            title="Eventos por cliente"
            params={{ event }}
            headerAction={
                <select
                    id={selectId}
                    className={styles.select}
                    aria-label="Evento"
                    value={event}
                    onChange={(e) => setEvent(e.target.value)}
                >
                    {options.map((o) => (
                        <option key={o.id} value={o.id}>
                            {o.label}
                        </option>
                    ))}
                </select>
            }
            formatters={FORMATTERS}
            exportFilename="analytics-eventos-por-cliente.xlsx"
            emptyMessage="Nenhuma conta no filtro."
            filters={filters}
            enabled={enabled}
            refreshKey={refreshKey}
            timeZone={timeZone}
        />
    );
}
